import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TrainerContext from "../../../context/trainerContext/TrainerContext";
import { isAccessAllowed } from "../../../utils/helpers";
import styles from "./Notes.module.scss";
import makeRequest from "../../../api";
import { trainerService, userService } from "../../../api/services";
import { toast } from "react-toastify";

const NotesListingPage = () => {
  const params = useParams();
  const userId = params.userId;

  const isNoteAddAllowed = isAccessAllowed("NOTES_ADD");

  const { getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();
  const { trainerId, trainerName } = trainerData;

  const [note, setNote] = useState<{ [key: string]: any }>({});
  const [notes, setNotes] = useState<any>([]);
  const [userDetails, setUserDetails] = useState<any>(null);

  const getUserData = async () => {
    try {
      const res = await makeRequest(userService.getUserDetails(userId));
      setUserDetails({ ...res?.data?.userDto });
    } catch (error: any) {
      toast.error("Error fetching user details!");
    }
  };

  useEffect(() => {
    if (userId) {
      getUserData();
    }
  }, [userId]);

  const fetchNotes = async () => {
    try {
      const res = await makeRequest(trainerService.getUserNotes(userId));
      setNotes([...res?.data?.body?.notes]);
    } catch (error: any) {
      toast.error("Error fetching user notes!");
    }
  };

  useEffect(() => {
    if (userId) {
      fetchNotes();
    }
  }, [userId]);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setNote({
      trainerDetails: {
        trainerId: trainerId,
        trainerName: trainerName,
      },
      text: value,
    });
  };

  const addNote = async (data: any) => {
    try {
      const res = await makeRequest(trainerService.addUserNotes(data, userId));
      fetchNotes();
      toast.success("Note added successfully.");
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    addNote(note);
    setNote({});
  };

  return (
    <div className="container-lg">
      <div className="row">
        {isNoteAddAllowed && (
          <div className={`${styles.stickyContainer} col-5 h-100`}>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  User Notes
                </li>
              </ol>
            </nav>
            {userDetails?.fullName && (
              <h6 className="fw-700 fs-24 mb-0 mt-2">
                {userDetails?.fullName}'s Notes
              </h6>
            )}
            <form className="mt-3" onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <textarea
                  className="form-control"
                  rows={10}
                  placeholder="Add note for user"
                  value={note?.text || ""}
                  name="note"
                  onChange={handleChange}
                />
              </div>
              <div className="form-group mb-3">
                <button type="submit" className="btn btn-outline-success px-4">
                  Add note
                </button>
              </div>
            </form>
          </div>
        )}
        <div className={isNoteAddAllowed ? "col-6 offset-1" : "col-6"}>
          {notes?.map((item: any, index: number) => (
            <div className="card p-3 mb-3" key={`notes-${index}`}>
              <div className="bold text-sm d-flex align-items-center justify-content-between">
                <strong>{item?.trainerDetails?.trainerName}</strong>
                <small>
                  {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                </small>
              </div>
              <p
                className="mb-0 mt-3"
                style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{ __html: item?.text }}
              />
            </div>
          ))}
          {notes?.length === 0 && <h6>No notes for user.</h6>}
        </div>
      </div>
    </div>
  );
};

export default NotesListingPage;
